module.exports = __webpack_public_path__ + "img/0120.e0adc8f2.png";